import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './companies.loaders';
import { converters } from './companies.converters';
import { CompaniesFilters, ParentCompaniesFilters } from './companies.types';

export const companiesKeys = queryKeyFactory('companies');

export const useCompanies = (filters: Partial<CompaniesFilters> = {}) => {
  return useQuery({
    queryKey: companiesKeys.list(filters),
    queryFn: () => loaders.getCompanies({ filters }),
    select: converters.getCompanies,
  });
};

export const useCompany = (companyId: string) => {
  return useQuery({
    queryKey: companiesKeys.detail(companyId),
    queryFn: () => loaders.getCompany({ companyId }),
    select: converters.getCompany,
    enabled: !!companyId,
  });
};

export const useCompanyContacts = (companyId: string) => {
  return useQuery({
    queryKey: companiesKeys.list('contacts', companyId),
    queryFn: () => loaders.getCompanyContacts({ companyId }),
    select: converters.getCompanyContacts,
    enabled: !!companyId,
  });
};

export const useParentCompanies = (
  filters: Partial<ParentCompaniesFilters> = {},
) => {
  return useQuery({
    queryKey: companiesKeys.list('parents', filters),
    queryFn: () => loaders.getParentCompanies({ filters }),
    select: converters.getParentCompanies,
  });
};
